import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { eq } from 'lodash';

import {
  PAGE_DATA, GENERAL_SETTINGS, UPDATE_GENERAL_SETTINGS, UPDATE_PAGE_DATA,
  CLIENT_STATE, SET_CLIENT_STATE,
} from '../../../graphqls';

export default function Prompt() {
  const { pathname } = useLocation();
  const paths = pathname.split('/');
  const {
    loading: loadingClientState,
    data: {
      modalTypeShown,
    } = {},
  } = useQuery(CLIENT_STATE);
  const {
    loading: loadingPageData,
    data: {
      pageData = {},
      pageData: {
        cache: {
          title,
          planNodeId,
        } = {},
      } = {},
    } = {},
  } = useQuery(PAGE_DATA, { variables: { name: eq(paths[1], 'home') ? 'home' : paths[2] } });
  const {
    loading: loadingGeneralSettings,
    data: {
      generalSettings = {},
      generalSettings: {
        childrenNameLabel,
        childrenDescriptionLabel,
        childrenStatusLabel,
      } = {},
    } = {},
  } = useQuery(GENERAL_SETTINGS);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const [updateGeneralSettings] = useMutation(UPDATE_GENERAL_SETTINGS, {
    refetchQueries: [{ query: GENERAL_SETTINGS }],
  });
  const [updatePageData] = useMutation(UPDATE_PAGE_DATA);
  const [titleInput, setTitleInput] = useState('');
  const [nameLabelInput, setNameLabelInput] = useState('');
  const [descriptionLabelInput, setDescriptionLabelInput] = useState('');
  const [statusInput, setStatusInput] = useState('');

  useEffect(() => {
    setTitleInput(title);
    setNameLabelInput(childrenNameLabel);
    setDescriptionLabelInput(childrenDescriptionLabel);
    setStatusInput(childrenStatusLabel);
  }, [pageData, generalSettings]);

  if (loadingGeneralSettings || loadingPageData || loadingClientState) {
    return '';
  }

  const onChange = ({
    target: {
      value,
      dataset: { type },
    },
  }) => {
    switch (type) {
      case 'name':
        setNameLabelInput(value);
        break;
      case 'description':
        setDescriptionLabelInput(value);
        break;
      case 'status':
        setStatusInput(value);
        break;
      case 'title':
        setTitleInput(value);
        break;
      default:
        break;
    }
  };

  const onSubmit = () => {
    switch (modalTypeShown) {
      case 'subPlanContentLabels':
        updateGeneralSettings({
          variables: {
            childrenNameLabel: nameLabelInput,
            childrenDescriptionLabel: descriptionLabelInput,
            childrenStatusLabel: statusInput,
          },
        });
        break;
      case 'title':
        updatePageData({
          variables: {
            name: planNodeId,
            cache: {
              title: titleInput,
              planNodeId,
            },
            itemId: planNodeId,
          },
        });
        break;
      default:
        break;
    }

    setState({ variables: { modalTypeShown: '' } });
  };

  let content;

  switch (modalTypeShown) {
    case 'subPlanContentLabels':
      content = (
        <>
          <div className="form-group">
            <label htmlFor="description-label">
              Description Label
              <input
                name="description-label"
                className="form-control form-control-description-label"
                value={descriptionLabelInput}
                data-type="description"
                onChange={onChange}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="status-label">
              Status Label
              <input
                name="status-label"
                className="form-control form-control-status-label"
                value={statusInput}
                data-type="status"
                onChange={onChange}
              />
            </label>
          </div>
        </>
      );
      break;
    case 'title':
      content = (
        <input
          name="plan-node-title"
          className="form-control form-control-plan-node-title"
          value={titleInput}
          data-type="title"
          onChange={onChange}
        />
      );
      break;
    default:
      break;
  }

  return (
    <div className="input-settings">
      {content}
      <div className="button-container">
        <button
          type="button"
          className="btn mint-btn"
          onClick={onSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
